/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section7_P1Inputs */

const en_privacy_section7_p1 = /** @type {(inputs: Privacy_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have any questions about this privacy policy, or want to know exactly what a given tool does with your input, contact the maintainer at the address below or open an issue on the GitHub repository.`)
};

const ko_privacy_section7_p1 = /** @type {(inputs: Privacy_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 개인정보처리방침에 대해 문의사항이 있거나 특정 도구가 입력값을 정확히 어떻게 다루는지 알고 싶다면, 아래 주소로 운영자에게 연락하거나 GitHub 저장소에 이슈를 등록해 주세요.`)
};

const ja_privacy_section7_p1 = /** @type {(inputs: Privacy_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプライバシーポリシーについてご質問がある場合、または特定のツールが入力をどう扱うか正確に知りたい場合は、下記アドレスから運営者にご連絡いただくか、GitHub リポジトリで issue を作成してください。`)
};

/**
* | output |
* | --- |
* | "If you have any questions about this privacy policy, or want to know exactly what a given tool does with your input, contact the maintainer at the address be..." |
*
* @param {Privacy_Section7_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section7_p1 = /** @type {((inputs?: Privacy_Section7_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section7_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section7_p1(inputs)
	if (locale === "ko") return ko_privacy_section7_p1(inputs)
	return ja_privacy_section7_p1(inputs)
});